import { IRootState } from '../../../../store'
import { IBodyAssessmentState } from '../store/bodyAssessment.types'

export const getBodyAssessmentSelector = (state: IRootState): IBodyAssessmentState => state.bodyAssessment
